import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const StatusUpdateModal = ({ isOpen, onClose, project, onUpdate }) => {
  const [formData, setFormData] = useState({
    status: project?.status || 'ongoing',
    progress: project?.progress || 0,
    notes: ''
  });

  const statusOptions = [
    { value: 'planned', label: 'مخطط' },
    { value: 'ongoing', label: 'جاري' },
    { value: 'completed', label: 'مكتمل' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onUpdate(project?.id, formData);
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (!isOpen || !project) return null;

  return (
    <div className="fixed inset-0 z-400 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-md animate-slide-up">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <h2 className="text-lg font-semibold text-foreground">
              تحديث حالة المشروع
            </h2>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              iconName="X"
              iconSize={20}
            />
          </div>

          {/* Content */}
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {/* Project Info */}
            <div className="bg-muted/30 rounded-lg p-4 mb-4">
              <h3 className="font-medium text-foreground mb-1">
                {project?.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {project?.description}
              </p>
            </div>

            {/* Status Selection */}
            <Select
              label="الحالة الجديدة"
              options={statusOptions}
              value={formData?.status}
              onChange={(value) => handleInputChange('status', value)}
              required
            />

            {/* Progress Input */}
            <div>
              <Input
                type="number"
                label="نسبة التقدم (%)"
                min="0"
                max="100"
                value={formData?.progress}
                onChange={(e) => handleInputChange('progress', parseInt(e?.target?.value) || 0)}
                required
              />
              
              {/* Progress Bar Preview */}
              <div className="mt-2">
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className="h-2 bg-primary rounded-full transition-all duration-300"
                    style={{ width: `${formData?.progress}%` }}
                  />
                </div>
              </div>
            </div>

            {/* Notes */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                ملاحظات التحديث
              </label>
              <textarea
                value={formData?.notes}
                onChange={(e) => handleInputChange('notes', e?.target?.value)}
                placeholder="أضف ملاحظات حول التحديث..."
                rows={3}
                className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
              />
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end space-x-3 pt-4">
              <Button
                type="button"
                variant="ghost"
                onClick={onClose}
              >
                إلغاء
              </Button>
              
              <Button
                type="submit"
                variant="default"
                iconName="Save"
                iconPosition="left"
                iconSize={16}
              >
                حفظ التحديث
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdateModal;